import { useEffect, useRef, useState } from 'react'
import { PATHS } from 'constants/paths'
import { useRouter } from 'next/router'

export const useIsBrowserRedirect = () => {
  const router = useRouter()
  const isFirstRender = useRef(true)
  const [fullPath, setFullPath] = useState('')

  useEffect(() => {
    const updateFullPath = () => {
      setFullPath(`${window.location.pathname}${window.location.hash}`)
    }

    updateFullPath()
    window.addEventListener('hashchange', updateFullPath)
    window.addEventListener('popstate', updateFullPath)

    return () => {
      window.removeEventListener('hashchange', updateFullPath)
      window.removeEventListener('popstate', updateFullPath)
    }
  }, [])

  useEffect(() => {
    setFullPath(`${router.pathname}${window.location.hash}`)
  }, [router.pathname])

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    if (fullPath === PATHS.BILLING || fullPath === PATHS.REVIEW) {
      router.push(PATHS.CART)
    }
  }, [fullPath, router])
}
